/*----------------------------------------------- GENERAL ANIMATE.CSS & WAYPOINT ANIMATIONS -----------------------------------------------*/
// $(document).ready(function() {
//   $('#coaching .element-to-fadeInUp').css('opacity', 0);

//   if(window.matchMedia("(min-width: 769px)").matches) {
//     $('#coaching .element-to-fadeInUp').waypoint(function() {
//       $(this.element).addClass('fadeInUp');
//     }, 
//     { offset: '125%' });
//   }

//   else {
//     $('#coaching .element-to-fadeInUp').waypoint(function() {
//       $(this.element).addClass('fadeInUp');
//     }, 
//     { offset: '155%' });    
//   }
// });



// $(document).ready(function() {
//   $('#core .element-to-fadeIn').css('opacity', 0);

//   if(window.matchMedia("(min-width: 769px)").matches) {
//     $('#core .element-to-fadeIn').waypoint(function() {
//       $(this.element).addClass('fadeIn');
//     }, 
//     { offset: '95%' });
//   }

//   else {
//     $('#core .element-to-fadeIn').waypoint(function() {
//       $(this.element).addClass('fadeIn');
//     }, 
//     { offset: '125%' });    
//   }
// });



// $(document).ready(function() {
//   $('#additional-kits .element-to-fadeIn').css('opacity', 0);

//   if(window.matchMedia("(min-width: 769px)").matches) {
//     $('#additional-kits .element-to-fadeIn').waypoint(function() {
//       $(this.element).addClass('fadeIn');
//     }, 
//     { offset: '125%' });
//   }

//   else {
//     $('#additional-kits .element-to-fadeIn').waypoint(function() {
//       $(this.element).addClass('fadeIn');
//     }, 
//     { offset: '155%' });    
//   }
// });



// $(document).ready(function() {
//   $('#additional-kits .element-to-fadeInDown').css('opacity', 0);

//   if(window.matchMedia("(min-width: 769px)").matches) {
//     $('#additional-kits .element-to-fadeInDown').waypoint(function() {
//       $(this.element).addClass('fadeInDown');
//     }, 
//     { offset: '125%' });
//   }

//   else {
//     $('#additional-kits .element-to-fadeInDown').waypoint(function() {
//       $(this.element).addClass('fadeInDown');
//     }, 
//     { offset: '155%' });    
//   }
// });



// $(document).ready(function() {
//   $('#app .element-to-fadeInLeft').css('opacity', 0);

//   if(window.matchMedia("(min-width: 769px)").matches) {
//     $('#app .element-to-fadeInLeft').waypoint(function() {
//       $(this.element).addClass('fadeInLeft');
//     }, 
//     { offset: '125%' });
//   }

//   else {
//     $('#app .element-to-fadeInLeft').waypoint(function() {
//       $(this.element).addClass('fadeInLeft');
//     }, 
//     { offset: '155%' });    
//   }
// });



// $(document).ready(function() {
//   $('#app .element-to-fadeInRight').css('opacity', 0);

//   if(window.matchMedia("(min-width: 769px)").matches) {
//     $('#app .element-to-fadeInRight').waypoint(function() {
//       $(this.element).addClass('fadeInRight');
//     }, 
//     { offset: '125%' });
//   }

//   else {
//     $('#app .element-to-fadeInRight').waypoint(function() {
//       $(this.element).addClass('fadeInRight');
//     }, 
//     { offset: '155%' });    
//   }
// });



$(document).ready(function() {
  $('#stats .element-to-fadeIn').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#stats .element-to-fadeIn').waypoint(function() {
      $(this.element).addClass('fadeIn');
    }, 
    { offset: '95%' });
  }

  else {
    $('#stats .element-to-fadeIn').waypoint(function() {
      $(this.element).addClass('fadeIn');
    }, 
    { offset: '125%' });    
  }
});
/*----------------------------------------------- GENERAL ANIMATE.CSS & WAYPOINT ANIMATIONS (END) -----------------------------------------------*/



$(document).ready(function() {

  $( "#purchase .results .input" ).on('click tap', function () {
    $('#purchase .cost h5').text(function(i, text){
        return text === "Monthly Price" ? "First Payment" : "Monthly Price";
    })
  })

});



// $(document).ready(function() {
//   if ($(window).width() < 770) {
//     jQuery("div#core-features .description-wrap-lg .description-wrap-sm .tile-container h5.h5-3tandai").removeClass("active-h5");
//   }
// });
// jQuery(window).load(function(){
//   if ($(window).width() < 770) {
//     jQuery("div#core-features .description-wrap-lg .description-wrap-sm .tile-container h5.h5-3tandai").removeClass("active-h5");
//   }
// });